module.exports = __webpack_public_path__ + "8d40a6cc0d625ce586d9c11575b7bc50.glb";